var __TEMP__ = require('./_basePropertyOf.js');var basePropertyOf = __REQUIRE_DEFAULT__(__TEMP__);

/** Used to map HTML entities to characters. */
var htmlUnescapes = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'"
};

/**
 * Used by `_.unescape` to convert HTML entities to characters.
 *
 * @private
 * @param {string} chr The matched character to unescape.
 * @returns {string} Returns the unescaped character.
 */
var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = unescapeHtmlChar;
